export const UTM_TAG = {
  UTM_SOURCE: "utm_source",
  UTM_MEDIUM: "utm_medium",
  UTM_CAMPAIGN: "utm_campaign",
  UTM_CONTENT: "utm_content"
};

export const UTM_SOURCE = {
  NOTIFICATION: "notification"
};

export const UTM_MEDIUM = {
  EMAIL: "email"
};

export const UTM_CAMPAIGN = {
  NOTIFICATION_EXTERNAL_CHANGES: "notif-gmb-ext-changes",
  NOTIFICATION_REVIEWS: "notif-gmb-reviews"
};
